import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import { Tracker } from '../Tracker';
import { SAFER_GAMBLING_EVENT_NAME } from './constants';

export var GamingTimeReminderTracker = function (_Tracker) {
  _inherits(GamingTimeReminderTracker, _Tracker);

  function GamingTimeReminderTracker() {
    _classCallCheck(this, GamingTimeReminderTracker);

    return _possibleConstructorReturn(this, (GamingTimeReminderTracker.__proto__ || _Object$getPrototypeOf(GamingTimeReminderTracker)).apply(this, arguments));
  }

  _createClass(GamingTimeReminderTracker, [{
    key: 'saveReminderClicked',
    value: function saveReminderClicked(reminderValue) {
      this.publishPartialEvent(SAFER_GAMBLING_EVENT_NAME, {
        EventLabel: this.parseReminderValueToEventLabel(reminderValue),
        EventAction: 'Gaming time reminder',
        SiteSectionCategory: 'Gaming time reminder'
      });
    }
  }, {
    key: 'parseReminderValueToEventLabel',
    value: function parseReminderValueToEventLabel(value) {
      var partialLabel = 'Time:';
      var integerValue = Number(value);
      var valueInMins = integerValue / 60;
      var valueInHours = integerValue / 3600;

      if (integerValue === 0) {
        return partialLabel + ' No reminder';
      } else if (integerValue < 3600) {
        return partialLabel + ' ' + valueInMins + ' mins';
      } else if (integerValue === 3600) {
        return partialLabel + ' ' + valueInHours + ' hour';
      } else {
        return partialLabel + ' ' + valueInHours + ' hours';
      }
    }
  }]);

  return GamingTimeReminderTracker;
}(Tracker);